module.exports = __webpack_public_path__ + "static/media/default-profile-pic.30ec60ef.png";